import { CAPACITY_STATUS } from "constants/index";
import { colors } from "style";

/**
 * resolveCapacityStatusColor
 *
 * @param {String} capacityStatus
 *
 * @returns {String} Color code based on the capacity status
 */
export default function resolveCapacityStatusColor(capacityStatus) {
  if (!capacityStatus) return null;

  return capacityStatus === CAPACITY_STATUS.offDuty ? colors.red : colors.green;
}
